var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotAvailableIcon = function SvgNotAvailableIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    d: "M18.774 4.697a.378.378 0 0 0-.63-.16l-2.697 2.69a.36.36 0 0 1-.295.114l-1.97-.182a.37.37 0 0 1-.341-.34l-.182-1.97a.4.4 0 0 1 .114-.304l2.697-2.69a.4.4 0 0 0 .099-.363.36.36 0 0 0-.266-.265A5.43 5.43 0 0 0 9.901 2.62a5.3 5.3 0 0 0-1.204 5.69.38.38 0 0 1-.084.402l-7.016 7.016a1.97 1.97 0 0 0-.454 2.159 1.91 1.91 0 0 0 3.076.576l7.069-7.077a.37.37 0 0 1 .401-.076 5.3 5.3 0 0 0 5.683-1.19 5.45 5.45 0 0 0 1.402-5.424z"
  })));
};
export { SvgNotAvailableIcon as ReactComponent };